import { head } from 'lodash';
import React, { useEffect, useRef, useState } from 'react'
import { getSnackbarSuccess } from '../../../Utils/helper';
import { useDispatch } from 'react-redux';

const AdvancePaymentEditModel = ({
    setIsOpenSetting,
    rowDetailsChangeHandler,
    rowDetails,
    OnRowDetailsIndexChangeHandler
}) => {

    const dispatch = useDispatch();
    const ref = useRef();
    const informationPermissions = JSON.parse(localStorage.getItem("NetworkMenuId"))["informationPermissions"]
    console.log("informationPermissions",informationPermissions)
    const [isDisable,setIsDisable]=useState(false);
    useEffect(()=>{
        const index = informationPermissions?.filter((i)=>i?.canEdit===true).findIndex((ele)=>ele?.informationName===rowDetails?.status)
        console.log("index", index);
        setIsDisable(index!==-1 ? false:true);
    },[])
    return (
        <div>
            <div
                className="d-flex justify-content-between border-bottom modalHeader"
                style={{ borderRadius: "10px 10px 0px 0px" }}
            >
                <h4 className="font-bold text-black">Advance Payment</h4>
                <button
                    type="button"
                    className="btn-close history-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                    onClick={() => {
                        setIsOpenSetting(false);
                    }}
                ></button>
            </div>
            <div className="select-time-interval ps-3 pe-3" id="andimni">
                <form onSubmit={(e) => {
                    e.preventDefault()
                    OnRowDetailsIndexChangeHandler(rowDetails, "submit",ref)
                }} className='row' id='addPaymentEdit' style={{ marginTop: "-30px" }}>
                    <div className='col-lg-6 col-sm-12 mt-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px", outline: "none",
                                border: "none", marginBottom: "-5px",
                                // letterSpacing: "1px"
                            }}
                        >Case No</label>
                        <input
                            type="text"
                            value={rowDetails?.caseNo ? rowDetails?.caseNo : ""}
                            className="white-form-select "

                            onChange={(e) => {
                                rowDetailsChangeHandler("caseNo", e.target.value)
                            }}
                            required
                            disabled
                        />
                    </div>

                    <div className='col-lg-6 col-sm-12 mt-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px", outline: "none",
                                border: "none", marginBottom: "-5px",
                                // letterSpacing: "1px"
                            }}
                        >Status</label>
                        <input
                            type="text"
                            value={rowDetails?.status ? rowDetails?.status : ""}
                            className="white-form-select "

                            onChange={(e) => {
                                rowDetailsChangeHandler("status", e.target.value)
                            }}
                            required
                            disabled
                        />
                    </div>

                    <div className='col-lg-6 col-sm-12 mt-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px",
                                outline: "none",
                                border: "none",
                                marginBottom: "-5px",
                                // letterSpacing: "1px",

                            }}>DC Amount</label>
                        <input
                            type="number"
                            value={rowDetails?.advancedDCAmt ? rowDetails?.advancedDCAmt : ""}
                            className="white-form-select "
                            min={1}
                            onChange={(e) => {
                                rowDetailsChangeHandler("advancedDCAmt", e.target.value)
                            }}
                            disabled={isDisable}
                            required
                        />
                    </div>

                    <div className='col-lg-6 col-sm-12 mt-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px",
                                outline: "none",
                                border: "none",
                                marginBottom: "-5px",
                                // letterSpacing: "1px",

                            }}>Insurer Amount</label>
                        <input
                            type="number"
                            value={rowDetails?.advancedInsurerAmt}
                            className="white-form-select "
                            min={1}
                            onChange={(e) => {
                                rowDetailsChangeHandler("advancedInsurerAmt", e.target.value)
                            }}
                            disabled={isDisable}
                            required
                        />
                    </div>
                    {(rowDetails?.status === 'Pending At Finance'||isDisable) && <div className='col-lg-6 col-sm-12 mt-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px",
                                outline: "none",
                                border: "none",
                                marginBottom: "-5px",
                                // letterSpacing: "1px",

                            }}>UTR</label>
                        <input
                            type="text"
                            value={rowDetails?.utr ? rowDetails?.utr : ""}
                            className="white-form-select "

                            onChange={(e) => {
                                rowDetailsChangeHandler("utr", e.target.value?.trimStart())
                            }}
                            required
                            disabled={isDisable}
                        />
                    </div>}

                    <div className='col-lg-6 col-sm-12 mt-4 mb-4'>
                        <label style=
                            {{
                                fontSize: "15px",
                                padding: "3px",
                                outline: "none",
                                border: "none",
                                marginBottom: "-5px",
                                // letterSpacing: "1px",

                            }}>Remarks</label>
                        <input
                            type="text"
                            value={rowDetails?.remarks ? rowDetails?.remarks : ""}
                            className="white-form-select "

                            onChange={(e) => {
                                rowDetailsChangeHandler("remarks", e.target.value)
                            }}
                            disabled={isDisable}
                        // required
                        />
                    </div>


                </form>
            </div>
            <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0">
                <div>


                </div>
                <div>
                    <button
                        type="button"
                        className="savedetails"
                        style={{ margin: "5px" }}
                        onClick={() => {
                            OnRowDetailsIndexChangeHandler(rowDetails, "clear",ref)
                        }}
                        disabled={isDisable}
                    >
                        Reset
                    </button>

                    <button
                        type="submit"
                        form='addPaymentEdit'
                        className="savedetails"
                        style={{ margin: "5px" }}
                        disabled={isDisable}

                    >
                        Submit
                    </button>
                    
                </div>
            </div>
        </div>
    )
}

export default AdvancePaymentEditModel